export default {
  trends: {
    filters: {
      title: "Filtros",
      trends: "Tendências",
      allTrends: "Todas as tendências",
      displayGames: "Exibir jogos",
      alternateLines: "Linhas alternativas",
    },
    list: {
      empty: {
        noPropsAvailable: "Nenhuma prop disponível",
        noTrendsAvailableYet: "Nenhuma tendência disponível ainda",
        needsThreeGamesMinimum: "Mínimo de 3 jogos necessário",
        pendingOddsCheckBack: "Odds pendentes. Volte mais tarde.",
      },
      preview: {
        comboTrendPreview: "Prévia de tendência combo",
        tryLinematePlus: "Experimente Linemate+",
      },
      actions: {
        addAllLegsToMyPicks: "Adicionar todos os legs às Minhas escolhas",
      },
    },
    cheatsheet: {
      title: "Guia rápido",
      separator: {
        noLongerHundredPercent: "ABAIXO NÃO É MAIS 100%",
      },
    },
    details: {
      labels: {
        trendsInThisParlay: "Tendências neste parlay",
        straights: "Simples",
        all: "Todas",
        hitRates: "Taxas de acerto",
        perGame: "Por jogo",
        against: "contra",
        rank: "Ranking",
        pitcher: "Arremessador",
        handedness: "Mão dominante",
        defensiveRanking: "Ranking defensivo",
      },
      actions: {
        addAllPicksAsParlay: "Adicionar todas as escolhas como parlay",
        removeAll: "Remover tudo",
      },
    },
  },
};
